import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-evalua-factura-respuesta",
  templateUrl: "./evalua-factura-respuesta.component.html",
  styleUrls: ["./evalua-factura-respuesta.component.scss"],
})
export class EvaluaFacturaRespuestaComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
